module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACDSURBVDiNY2AYBdQFDQ0NHH19fcm45Lu6uiR6e3tjkMWYkDmioqIs////T+zt7e3HppmZmXk/AwODDrI4I7rCqVOn8vz48WMHAwPD6eLi4kJkzf///99ZUlJSgNcAdEP+/v3biUszTgPQDNH+////QmyaCYKpU6fy9PT0pJCscRSQBgBl2j6orGv/SwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down2.png
// module id = kayv
// module chunks = 18